import React, { useEffect, useState } from 'react'
import TableFixedPage from '../../TableFixedPage/TableFixedPage'
import ResturantCategoryListTabel from '../../Tables/Category/ResturantCategoryListTabel/ResturantCategoryListTabel'
import { RemoveResturantCategoryAPI, getResturantCategoryAPI, updateResturantCategoryAPI } from '../../../Api/PanelAdminServices'
import {  Modal } from "react-bootstrap";
import Button from "../../Button/Button";
import { errorToast, succToast } from '../../../Utils/Toast/Toast';

const ResturantCategoryListContainer = () => {
    const[CategoryData,setCategoryData]=useState(null)
    const[CategoryInfo,setCategoryInfo]=useState(null)
    const[ShowmodalState,setShowmodalState]=useState(null)
    const[ShowEditModalState,setShowEditModalState]=useState(null)
    const[CategoryPersion,setCategoryPersion]=useState(null)
    const[CategoryEnglish,setCategoryEnglish]=useState(null)
    const[loadingBtn,setLoadingBtn]=useState(false)
    const[disableRemove,setDisableRemove]=useState(false)

    const showModalHandler = (value,data) => {
        setCategoryInfo(data)
        if(value===2){
            setShowmodalState(true)
        }
        if(value===1){
            setShowEditModalState(true)
            setCategoryPersion(data.pName)
            setCategoryEnglish(data.eName)
        }
      };
      useEffect(()=>{
        getBrandDataHandler()
      },[])
      const getBrandDataHandler=async()=>{
        getResturantCategoryAPI((succ,res)=>{
          if(succ){
            if(res.status===0){
              errorToast("مشکلی پیش آمده است")
            }else{
              setCategoryData(res.category)
            }
          }else{
            errorToast("خطایی در سرور رخ داده است")
          }
        })
      }
      const HideModlaHandler=()=>{
        setShowmodalState(false)
        setShowEditModalState(false)
      }
      const RemoveResturantCategoryHandler=()=>{
        setDisableRemove(true)
        let info={
          id:CategoryInfo.id
        }
        RemoveResturantCategoryAPI(info, (succ) => {
          if (succ.status === 1) {
            succToast(succ.message);
            getBrandDataHandler()
            HideModlaHandler()
            setDisableRemove(false)
          } else {
            errorToast(succ.message);
            setDisableRemove(false)
            }
          });
      }

      const EditeResturantCategoryHandler=()=>{
        let info={
          id:CategoryInfo.id,
          category_persian:CategoryPersion,
          category_english:CategoryEnglish,
        }
        setLoadingBtn(true)
        updateResturantCategoryAPI(info, (succ) => {
            if (succ.status === 1) {
              succToast(succ.message);
              getBrandDataHandler()
              HideModlaHandler()
              setLoadingBtn(false)
            } else {
              errorToast(succ.message);
              setLoadingBtn(false)
            }
          });
      }
  return (
    <div>
        <TableFixedPage title={"لیست دسته بندی رستوران"} />
        <Modal show={ShowmodalState} onHide={HideModlaHandler} >
        <Modal.Header>
          <Modal.Title style={{fontSize:'1rem',width:'100%',direction:'rtl'}}>
            آیا از حذف دسته بندی موردنظر مطمئن هستید؟
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "space-around",
            }}
          >
            <Button
              ClassBtn={"rejectBtn"}
              Value={"خیر"}
              ClickHandler={HideModlaHandler}
            />
            <Button
              ClassBtn={"confirmBtn"}
              Value={"بله"}
              ClickHandler={RemoveResturantCategoryHandler}
              disabledProps={disableRemove}
            />
          </div>
        </Modal.Body>
      </Modal>
        <Modal show={ShowEditModalState} onHide={HideModlaHandler} >
        <Modal.Header>
          <Modal.Title style={{fontSize:'1rem',width:'100%',direction:'rtl'}}>
            ویرایش برند
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
        <section style={{display:'flex',flexDirection:'column',alignItems:'center',width:'100%'}}>
        <input
            style={{width:'98%',height:'3rem',borderRadius:'5px',margin:'0.5rem 0',textAlign:'right',border:'none',boxShadow:'0 1px 3px rgba(0, 0, 0, 0.253)'}}
              placeholder={"برند به فارسی"}
              onChange={e=>setCategoryPersion(e.target.value)}
              value={CategoryPersion}
            />
            <input
            style={{width:'98%',height:'3rem',borderRadius:'5px',margin:'0.5rem 0',textAlign:'right',border:'none',boxShadow:'0 1px 3px rgba(0, 0, 0, 0.253)'}}
              placeholder={"برند به انگلیسی"}
              onChange={e=>setCategoryEnglish(e.target.value)}
              value={CategoryEnglish}
            />
            <div
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "space-around",
              margin:'1rem 0'
            }}
          >
            <Button
              ClassBtn={"rejectBtn"}
              Value={"لغو"}
              ClickHandler={HideModlaHandler}
            />
            <Button
              ClassBtn={"confirmBtn"}
              Value={loadingBtn?'منتظرباشید!':'ثبت'}
              ClickHandler={EditeResturantCategoryHandler}
              disabledProps={loadingBtn}
              
            />
          </div>
        </section>
        </Modal.Body>
      </Modal>
        <ResturantCategoryListTabel openModal={showModalHandler} data={CategoryData}/>
    </div>
  )
}

export default ResturantCategoryListContainer